import React, { useMemo } from 'react';

import { SpammerEntity } from '../SpammerEntity';

export const SpammerNodeView = ({ node }) => {
  const dataTarget = useMemo(() => node.attrs.id, [node.attrs.id]);

  const spammer = useMemo(() => (dataTarget ? { id: dataTarget } : null), [dataTarget]);

  return (
    <span data-node-view-wrapper>
      <SpammerEntity spammer={spammer} dataTarget={dataTarget} truncated />
    </span>
  );
};
